import { useGetPerson } from '@my-pages/hooks/useGetPerson';
import { EmploymentPageContentResponseModel } from '@shared/integrations/umbraco-taf-delivery-api/models';
import { createRef, useEffect, useState } from 'react';
import { useGetApiV2MemberEmployments } from '@shared/integrations/taf-api/v2/features/member/member.ts';
import { getPagePositionOfElement, smoothScroll } from '@shared/utils/misc';
import Alerts from '@shared/components/Alerts.tsx';
import { EmploymentFormsWrapper } from '@my-pages/features/employment/Forms';
import OccupationStatuses from '@my-pages/features/employment/components/Occupation/OccupationStatuses.tsx';
import Employments from '@my-pages/features/employment/components/Employment/Employments.tsx';
import IncomeCard from '@my-pages/features/employment/components/IncomeCard.tsx';
import ToggleEmploymentFormsCard from '@my-pages/features/employment/components/ToggleEmploymentFormsCard.tsx';
import { EmploymentUpdateStatus } from '@my-pages/features/employment/types';
import EmploymentUpdatedBanner from "@my-pages/features/employment/Forms/EmploymentUpdatedBanner.tsx";

interface IEmploymentPage {
    content: EmploymentPageContentResponseModel;
}

//@ts-ignore
const EmploymentPage = ({ content }: IEmploymentPage) => {
    const member = useGetPerson();
    const { data } = useGetApiV2MemberEmployments();
    const employmentFormsCard = createRef<HTMLDivElement>();
    const [selectedForm, setSelectedForm] = useState(null);
    const [displayMessage, setDisplayMessage] = useState<EmploymentUpdateStatus | null>(null);
    useEffect(() => {
        smoothScroll(0);
    }, [selectedForm]);

    const ScrollToEmploymentCards = () => {
        if (employmentFormsCard.current) smoothScroll(getPagePositionOfElement(employmentFormsCard.current));
    };

    return (
        <div>
            <h1 className='page-title'>Yrkesstatus, anställning & inkomst</h1>
            <div className='slide-up-fade-in'>
                {content?.properties?.importantMessages && (
                    <div className='mb-4'>
                        <Alerts alerts={content?.properties?.importantMessages} />
                    </div>
                )}
                {displayMessage && <EmploymentUpdatedBanner status={displayMessage} closeDisplayMessage={() => setDisplayMessage(null)} />}
                
                {selectedForm && <EmploymentFormsWrapper closeForm={() => setSelectedForm(null)}>{selectedForm}</EmploymentFormsWrapper>}

                {member ? (
                    <OccupationStatuses
                        person={member}
                        onClickChange={ScrollToEmploymentCards}
                    />
                ) : null}

                {data && ((data.current && data.current.length > 0) || (data.next && data.next.length > 0)) && (
                    <Employments
                        currentEmployments={data.current}
                        nextEmployments={data.next}
                        onClickChange={ScrollToEmploymentCards}
                    />
                )}
                <IncomeCard
                    employments={data?.current}
                    onClickChange={ScrollToEmploymentCards}
                />
                <div ref={employmentFormsCard}>
                    <ToggleEmploymentFormsCard setSelectedForm={setSelectedForm} setDisplayMessage={setDisplayMessage} />
                </div>
            </div>
        </div>
    );
};

export default EmploymentPage;
